<div class="filters">
  <div class="schedule">
    <button
      md-raised-button
      color="primary"
      (click)="createSchedule()"
      *ngIf="canScheduleMagicBox"
    >
      <md-icon>schedule</md-icon>
      Schedule Magic Box
    </button>
    <button
      md-raised-button
      color="accent"
      (click)="createRule()"
      *ngIf="editMode"
      [disabled]="disabledEditing"
    >
      <md-icon>create</md-icon>
      Create new rule
    </button>
    <br />
  </div>
  <div class="container">
    <app-spinner *ngIf="loading"></app-spinner>
    <md-card *ngIf="!loading">
      <div class="title">
        <div class="text center-text">
          <div class="tooltip">
            Find a Rule
            <span class="tooltiptext"
              >Find existing rule by entering your criteria
            </span>
          </div>
        </div>
      </div>
      <div class="buttons">
        <md-form-field>
          <input
            name="term"
            type="text"
            mdInput
            [(ngModel)]="filters.id"
            placeholder="Id"
            (keyup.enter)="searchRules()"
          />
        </md-form-field>
      </div>
      <div class="force-inter">
        <md-slide-toggle [(ngModel)]="filters.showDeleted"
          >Show deleted rules</md-slide-toggle
        >
      </div>
      <hr />
      <div class="title">
        <div class="text">Classification</div>
        <md-icon (click)="resetSelectors()" mdTooltip="Reset selection"
          >replay</md-icon
        >
      </div>
      <div class="AlignWrapper">
        <div class="Sport">Sport</div>
        <div>
          <md-slide-toggle
            [checked]="midnightMode"
            (change)="changeTypeClassification($event)"
          ></md-slide-toggle>
        </div>
        <div class="NonSport">Non Sport</div>
      </div>
      <div class="selectors">
        <app-list-selector
          *ngFor="let type of referentialTypes"
          [type]="type"
          [multiple]="false"
          [values]="[]"
          [forceInter]="forceInter"
          [selected]="getFiltersSelectorValue(type)"
          [includeMode]="true"
          [nonSport]="isNonSportiveClassif"
          #selector
        >
        </app-list-selector>
      </div>
      <div class="force-inter">
        <md-slide-toggle [(ngModel)]="forceInter" (change)="forceInterChanged()"
          >Force language INTER</md-slide-toggle
        >
      </div>
      <hr />
      <div class="subtype">
        <div class="title">
          <div class="text">Field</div>
        </div>
        <div class="buttons">
          <md-radio-group [(ngModel)]="filters.for" class="destinations-group">
            <md-radio-button *ngFor="let field of fields" [value]="field.id">{{
              field.value
            }}</md-radio-button>
          </md-radio-group>
        </div>
      </div>
      <hr />
      <div class="mediatype">
        <div class="title">
          <div class="text">Destination</div>
        </div>
        <div class="checkboxes">
          <md2-select
            [(ngModel)]="applyToSelector"
            [multiple]="true"
            (change)="applyToChange()"
          >
            <md2-option
              *ngFor="let destination of destinations"
              [value]="destination.value"
              >{{ destination.value }}
            </md2-option>
          </md2-select>
        </div>
      </div>
      <hr />
      <div class="buttons">
        <button
          md-raised-button
          color="primary"
          (click)="searchRules()"
          [disabled]="disableSearch"
        >
          <md-icon>search</md-icon>
          Search for a rule
        </button>
        <button
          *ngIf="filters.for !== 4"
          md-raised-button
          color="primary"
          (click)="extract()"
          [disabled]="disableSearch"
        >
          <md-icon>download</md-icon>
          Extract Magic Box Rules
        </button>
      </div>
    </md-card>
  </div>
</div>

<div class="wrapper">
  <router-outlet></router-outlet>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/magic-box/magic-box.component.html